import React, { useState, useEffect, useCallback } from 'react';
import { t } from '../i18n';

// XpertCareers — Rozee-style jobs. Freelance (gigs/projects) se alag.
const API = '/api/careers';
const C = {
  primary: '#059669', primaryBg: '#ECFDF5', indigo: '#4f46e5',
  border: '#E2E8F0', text: '#1E293B', muted: '#64748B', surface: '#fff', bg: '#F8FAF9',
  danger: '#C0392B',
};
const H = (json = true) => {
  const h = {};
  const tk = localStorage.getItem('token');
  if (tk) h['Authorization'] = `Token ${tk}`;
  if (json) h['Content-Type'] = 'application/json';
  return h;
};
const isSuper = () => localStorage.getItem('username') === 'khalidxpert';

const card = { background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '0.9rem', marginBottom: 10 };
const inp = { width: '100%', padding: '9px 11px', fontSize: 14, border: `0.5px solid ${C.border}`, borderRadius: 8, boxSizing: 'border-box', marginBottom: 8, background: '#fff' };
const btn = (bg = C.primary) => ({ padding: '9px 16px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: bg, color: '#fff', cursor: 'pointer' });
const btnGhost = { padding: '7px 12px', fontSize: 12, border: `0.5px solid ${C.border}`, borderRadius: 8, background: '#fff', cursor: 'pointer', color: C.text };
const chip = (on) => ({ padding: '5px 12px', fontSize: 12, borderRadius: 14, border: `0.5px solid ${on ? C.primary : C.border}`, background: on ? C.primaryBg : '#fff', color: on ? C.primary : C.muted, cursor: 'pointer', whiteSpace: 'nowrap' });

function payPi(amount, memo, meta, approveUrl, completeUrl, onDone, onFail) {
  if (!window.Pi) { alert('Pi Browser required for payments'); onFail(); return; }
  window.Pi.authenticate(['payments'], () => {}).then(() => {
    window.Pi.createPayment(
      { amount, memo, metadata: meta },
      {
        onReadyForServerApproval: (paymentId) => {
          fetch(approveUrl, { method: 'POST', headers: H(), body: JSON.stringify({ payment_id: paymentId }) });
        },
        onReadyForServerCompletion: async (paymentId, txid) => {
          try {
            const r = await fetch(completeUrl, { method: 'POST', headers: H(), body: JSON.stringify({ payment_id: paymentId, txid }) });
            const d = await r.json();
            if (!r.ok) throw new Error(d.error || 'complete failed');
            onDone(d);
          } catch (e) { alert('Payment completion failed: ' + e.message); onFail(); }
        },
        onCancel: () => onFail(),
        onError: () => { alert('Payment error'); onFail(); },
      }
    );
  }).catch(() => { alert('Pi authentication failed'); onFail(); });
}

const salaryTxt = (j) => {
  if (!j.salary_min && !j.salary_max) return t('cr_salary_hidden');
  if (j.salary_min && j.salary_max) return `PKR ${j.salary_min.toLocaleString()} - ${j.salary_max.toLocaleString()} ${t('cr_per_month')}`;
  return `PKR ${(j.salary_min || j.salary_max).toLocaleString()} ${t('cr_per_month')}`;
};

function JobCard({ j, onOpen }) {
  return (
    <div style={{ ...card, cursor: 'pointer', borderLeft: j.is_featured ? `3px solid ${C.indigo}` : `0.5px solid ${C.border}` }} onClick={() => onOpen(j.id)}>
      <p style={{ fontSize: 15, fontWeight: 700, margin: 0, color: C.text }}>{j.title} {j.is_featured && <span style={{ fontSize: 10, background: C.indigo, color: '#fff', borderRadius: 6, padding: '2px 7px', marginLeft: 6 }}>★ {t('cr_featured')}</span>}</p>
      <p style={{ fontSize: 13, color: C.muted, margin: '3px 0 0' }}>🏢 {j.company_name}{j.city ? ` · 📍 ${j.city}` : ''}</p>
      <p style={{ fontSize: 12, color: C.text, margin: '8px 0 0' }}>💰 {salaryTxt(j)} · <span style={{ color: C.indigo }}>{j.job_type.replace('_', ' ')}</span></p>
      <p style={{ fontSize: 11, color: C.muted, margin: '6px 0 0' }}>{j.created_at} · {j.applications_count} {t('cr_applicants_n')}</p>
    </div>
  );
}

function ApplyModal({ job, onClose, onApplied }) {
  const [src, setSrc] = useState('cvbuilder');
  const [pdf, setPdf] = useState(null);
  const [note, setNote] = useState('');
  const [cvOk, setCvOk] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch('/api/freelance/cv/', { headers: H() }).then((r) => r.json()).then((d) => setCvOk(!!d.exists)).catch(() => setCvOk(false));
  }, []);

  const submit = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('cv_source', src);
      fd.append('cover_note', note);
      if (src === 'pdf' && pdf) fd.append('cv_pdf', pdf);
      const r = await fetch(`${API}/jobs/${job.id}/apply/`, { method: 'POST', headers: H(false), body: fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'apply failed');
      alert('✅ ' + t('cr_applied_ok'));
      onApplied();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 14, padding: '1.2rem', width: '100%', maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <p style={{ fontSize: 15, fontWeight: 700, margin: '0 0 10px' }}>{t('cr_apply')}: {job.title}</p>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <button style={chip(src === 'cvbuilder')} onClick={() => setSrc('cvbuilder')}>📄 {t('cr_use_cvb')}</button>
          <button style={chip(src === 'pdf')} onClick={() => setSrc('pdf')}>📎 {t('cr_upload_pdf')}</button>
        </div>
        {src === 'cvbuilder' && cvOk === false && (
          <p style={{ fontSize: 12, color: C.danger, margin: '0 0 8px' }}>{t('cr_no_cv')} <a href="/cv-builder" style={{ color: C.indigo }}>CV Builder →</a></p>
        )}
        {src === 'pdf' && (
          <input type="file" accept="application/pdf" style={{ ...inp, padding: 8 }} onChange={(e) => setPdf(e.target.files[0])} />
        )}
        <textarea style={{ ...inp, minHeight: 80 }} placeholder={t('cr_cover_ph')} value={note} onChange={(e) => setNote(e.target.value)} />
        <button style={{ ...btn(), width: '100%', opacity: busy ? 0.6 : 1 }} disabled={busy || (src === 'cvbuilder' && cvOk === false) || (src === 'pdf' && !pdf)} onClick={submit}>
          {busy ? '...' : t('cr_submit_app')}
        </button>
      </div>
    </div>
  );
}

function JobDetail({ jobId, onBack }) {
  const [j, setJ] = useState(null);
  const [applyOpen, setApplyOpen] = useState(false);
  const load = useCallback(() => {
    fetch(`${API}/jobs/${jobId}/`, { headers: H() }).then((r) => r.json()).then(setJ);
  }, [jobId]);
  useEffect(() => { load(); }, [load]);
  if (!j) return <p style={{ color: C.muted, padding: '2rem 0', textAlign: 'center' }}>{t('cr_loading')}</p>;
  const loggedIn = !!localStorage.getItem('token');
  return (
    <div>
      <button style={btnGhost} onClick={onBack}>← {t('cr_back')}</button>
      <div style={{ ...card, marginTop: 10 }}>
        <p style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>{j.title}</p>
        <p style={{ fontSize: 13, color: C.muted, margin: '4px 0 0' }}>🏢 {j.company_name}{j.city ? ` · 📍 ${j.city}` : ''} · {j.job_type.replace('_', ' ')}</p>
        <p style={{ fontSize: 13, margin: '8px 0 0' }}>💰 {salaryTxt(j)}</p>
        {j.description && (<><p style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 4px' }}>{t('cr_desc')}</p><p style={{ fontSize: 13, whiteSpace: 'pre-wrap', margin: 0, lineHeight: 1.6 }}>{j.description}</p></>)}
        {j.requirements && (<><p style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 4px' }}>{t('cr_reqs')}</p><p style={{ fontSize: 13, whiteSpace: 'pre-wrap', margin: 0, lineHeight: 1.6 }}>{j.requirements}</p></>)}
        {j.company_about && (<><p style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 4px' }}>{t('cr_about_co')}</p><p style={{ fontSize: 13, whiteSpace: 'pre-wrap', margin: 0 }}>{j.company_about}</p></>)}
        <div style={{ marginTop: 14 }}>
          {!loggedIn ? <p style={{ fontSize: 12, color: C.muted }}>{t('cr_login_apply')}</p>
            : j.already_applied ? <span style={{ fontSize: 13, color: C.primary, fontWeight: 600 }}>✅ {t('cr_already')}</span>
              : <button style={btn()} onClick={() => setApplyOpen(true)}>{t('cr_apply')}</button>}
        </div>
      </div>
      {applyOpen && <ApplyModal job={j} onClose={() => setApplyOpen(false)} onApplied={() => { setApplyOpen(false); load(); }} />}
    </div>
  );
}

function BrowseTab() {
  const [jobs, setJobs] = useState([]);
  const [cats, setCats] = useState([]);
  const [types, setTypes] = useState([]);
  const [q, setQ] = useState('');
  const [city, setCity] = useState('');
  const [cat, setCat] = useState('');
  const [jt, setJt] = useState('');
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const p = new URLSearchParams();
    if (q) p.set('q', q);
    if (city) p.set('city', city);
    if (cat) p.set('category', cat);
    if (jt) p.set('job_type', jt);
    const r = await fetch(`${API}/jobs/?${p.toString()}`);
    const d = await r.json();
    setJobs(d.jobs || []);
    setLoading(false);
  }, [q, city, cat, jt]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    fetch(`${API}/jobs/categories/`).then((r) => r.json()).then((d) => { setCats(d.categories || []); setTypes(d.job_types || []); });
  }, []);

  if (openId) return <JobDetail jobId={openId} onBack={() => { setOpenId(null); load(); }} />;
  return (
    <div>
      <div style={{ background: `linear-gradient(135deg, ${C.primary}, ${C.indigo})`, borderRadius: 14, padding: '1.2rem', marginBottom: 12 }}>
        <p style={{ color: '#fff', fontSize: 17, fontWeight: 700, margin: '0 0 8px' }}>{t('cr_hero')}</p>
        <input style={{ ...inp, marginBottom: 6 }} placeholder={t('cr_search_ph')} value={q} onChange={(e) => setQ(e.target.value)} />
        <input style={{ ...inp, marginBottom: 0 }} placeholder={t('cr_city_ph')} value={city} onChange={(e) => setCity(e.target.value)} />
      </div>
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 6, marginBottom: 4 }}>
        <button style={chip(!cat)} onClick={() => setCat('')}>{t('cr_all')}</button>
        {cats.map((c) => <button key={c.key} style={chip(cat === c.key)} onClick={() => setCat(c.key)}>{c.label}</button>)}
      </div>
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 6, marginBottom: 8 }}>
        <button style={chip(!jt)} onClick={() => setJt('')}>{t('cr_all_types')}</button>
        {types.map((x) => <button key={x.key} style={chip(jt === x.key)} onClick={() => setJt(x.key)}>{x.label}</button>)}
      </div>
      {loading ? <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>{t('cr_loading')}</p>
        : jobs.length === 0 ? <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>{t('cr_no_jobs')}</p>
          : jobs.map((j) => <JobCard key={j.id} j={j} onOpen={setOpenId} />)}
      <p style={{ fontSize: 12, color: C.muted, textAlign: 'center', marginTop: 14 }}>⚡ {t('cr_gig_hint')} <a href="/freelance" style={{ color: C.indigo }}>Freelance →</a></p>
    </div>
  );
}

function MyAppsTab() {
  const [apps, setApps] = useState(null);
  useEffect(() => {
    fetch(`${API}/applications/mine/`, { headers: H() }).then((r) => r.json()).then((d) => setApps(d.applications || []));
  }, []);
  const stColor = { applied: C.muted, shortlisted: C.indigo, interview: '#0891b2', hired: C.primary, rejected: C.danger };
  if (!apps) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>{t('cr_loading')}</p>;
  if (apps.length === 0) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>{t('cr_no_apps')}</p>;
  return apps.map((a) => (
    <div key={a.id} style={card}>
      <p style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>{a.job_title}</p>
      <p style={{ fontSize: 12, color: C.muted, margin: '3px 0 6px' }}>🏢 {a.company} · {a.created_at}</p>
      <span style={{ fontSize: 12, fontWeight: 700, color: stColor[a.status] || C.muted }}>● {t('cr_st_' + a.status)}</span>
    </div>
  ));
}

function ApplicantsView({ job, onBack }) {
  const [apps, setApps] = useState(null);
  const [openCv, setOpenCv] = useState(null);
  const load = useCallback(() => {
    fetch(`${API}/jobs/${job.id}/applications/`, { headers: H() }).then((r) => r.json()).then((d) => setApps(d.applications || []));
  }, [job.id]);
  useEffect(() => { load(); }, [load]);
  const setSt = async (id, st) => {
    await fetch(`${API}/applications/${id}/status/`, { method: 'POST', headers: H(), body: JSON.stringify({ status: st }) });
    load();
  };
  return (
    <div>
      <button style={btnGhost} onClick={onBack}>← {t('cr_back')}</button>
      <p style={{ fontSize: 15, fontWeight: 700, margin: '10px 0' }}>{t('cr_applicants')}: {job.title}</p>
      {!apps ? <p style={{ color: C.muted }}>{t('cr_loading')}</p>
        : apps.length === 0 ? <p style={{ color: C.muted }}>{t('cr_no_apps_yet')}</p>
          : apps.map((a) => (
            <div key={a.id} style={card}>
              <p style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>@{a.applicant} <span style={{ fontSize: 11, color: C.muted, fontWeight: 400 }}>· {a.created_at}</span></p>
              {a.cover_note && <p style={{ fontSize: 12, margin: '6px 0', whiteSpace: 'pre-wrap' }}>{a.cover_note}</p>}
              <div style={{ margin: '6px 0' }}>
                {a.cv_source === 'pdf' && a.cv_pdf
                  ? <a href={a.cv_pdf} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: C.indigo }}>📎 {t('cr_view_pdf')}</a>
                  : <button style={btnGhost} onClick={() => setOpenCv(openCv === a.id ? null : a.id)}>📄 {openCv === a.id ? t('cr_hide_cv') : t('cr_view_cv')}</button>}
              </div>
              {openCv === a.id && a.cv_snapshot && (
                <div style={{ background: C.bg, borderRadius: 8, padding: 10, fontSize: 12, lineHeight: 1.6 }}>
                  <b>{a.cv_snapshot.full_name}</b> - {a.cv_snapshot.headline}<br />
                  {a.cv_snapshot.email} · {a.cv_snapshot.phone} · {a.cv_snapshot.city}<br />
                  {a.cv_snapshot.summary && <p style={{ margin: '6px 0' }}>{a.cv_snapshot.summary}</p>}
                  {a.cv_snapshot.skills && <p style={{ margin: '6px 0' }}>🛠 {a.cv_snapshot.skills}</p>}
                  {(a.cv_snapshot.experience || []).map((e, i) => <p key={i} style={{ margin: '4px 0' }}>💼 {e.title || ''} - {e.company || ''} {e.years || e.period || ''}</p>)}
                  {(a.cv_snapshot.education || []).map((e, i) => <p key={i} style={{ margin: '4px 0' }}>🎓 {e.degree || ''} - {e.institute || e.school || ''}</p>)}
                </div>
              )}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
                {['shortlisted', 'interview', 'hired', 'rejected'].map((st) => (
                  <button key={st} style={chip(a.status === st)} onClick={() => setSt(a.id, st)}>{t('cr_st_' + st)}</button>
                ))}
              </div>
            </div>
          ))}
    </div>
  );
}

function EmployerTab() {
  const [co, setCo] = useState(null);
  const [form, setForm] = useState({ name: '', city: '', website: '', about: '' });
  const [jobs, setJobs] = useState([]);
  const [jf, setJf] = useState({ title: '', category: 'other', job_type: 'full_time', city: '', salary_min: '', salary_max: '', description: '', requirements: '' });
  const [showPost, setShowPost] = useState(false);
  const [appsFor, setAppsFor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [cats, setCats] = useState([]);
  const [types, setTypes] = useState([]);

  const loadCo = useCallback(() => {
    fetch(`${API}/company/mine/`, { headers: H() }).then((r) => r.json()).then((d) => {
      setCo(d);
      if (d.exists) setForm({ name: d.name, city: d.city, website: d.website, about: d.about });
    });
  }, []);
  const loadJobs = useCallback(() => {
    fetch(`${API}/jobs/mine/`, { headers: H() }).then((r) => r.json()).then((d) => setJobs(d.jobs || []));
  }, []);
  useEffect(() => { loadCo(); loadJobs(); }, [loadCo, loadJobs]);
  useEffect(() => {
    fetch(`${API}/jobs/categories/`).then((r) => r.json()).then((d) => { setCats(d.categories || []); setTypes(d.job_types || []); });
  }, []);

  const saveCo = async () => {
    const r = await fetch(`${API}/company/save/`, { method: 'POST', headers: H(), body: JSON.stringify(form) });
    const d = await r.json();
    if (!r.ok) { alert(d.error || 'failed'); return; }
    alert('✅ ' + (d.status === 'approved' ? t('cr_co_ok') : t('cr_co_pending')));
    loadCo();
  };

  const postJob = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/jobs/create/`, { method: 'POST', headers: H(), body: JSON.stringify(jf) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'failed');
      if (d.needs_payment) {
        if (!window.confirm(`${t('cr_fee_note')} ${d.fee_pi} Pi`)) { setBusy(false); loadJobs(); return; }
        payPi(d.fee_pi, `XpertCareers job post: ${jf.title}`, { job_id: d.id, type: 'careers_post' },
          `${API}/jobs/${d.id}/pay/approve/`, `${API}/jobs/${d.id}/pay/complete/`,
          () => { alert('✅ ' + t('cr_job_live')); setBusy(false); setShowPost(false); loadJobs(); loadCo(); },
          () => { setBusy(false); loadJobs(); });
        return;
      }
      alert('✅ ' + t('cr_job_live'));
      setShowPost(false);
      setJf({ title: '', category: 'other', job_type: 'full_time', city: '', salary_min: '', salary_max: '', description: '', requirements: '' });
      loadJobs(); loadCo();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const feature = (j) => {
    if (!window.confirm(`${t('cr_feature_note')} ${co.featured_fee_pi} Pi`)) return;
    if (isSuper()) {
      fetch(`${API}/jobs/${j.id}/feature/complete/`, { method: 'POST', headers: H(), body: JSON.stringify({ payment_id: 'super', txid: 'super' }) })
        .then(() => { alert('✅ Featured'); loadJobs(); });
      return;
    }
    payPi(co.featured_fee_pi, `XpertCareers featured: ${j.title}`, { job_id: j.id, type: 'careers_feature' },
      `${API}/jobs/${j.id}/feature/approve/`, `${API}/jobs/${j.id}/feature/complete/`,
      () => { alert('✅ Featured!'); loadJobs(); }, () => {});
  };

  const closeJob = async (j) => {
    if (!window.confirm(t('cr_close_confirm'))) return;
    await fetch(`${API}/jobs/${j.id}/close/`, { method: 'POST', headers: H() });
    loadJobs();
  };

  if (appsFor) return <ApplicantsView job={appsFor} onBack={() => { setAppsFor(null); loadJobs(); }} />;
  if (!co) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>{t('cr_loading')}</p>;

  return (
    <div>
      <div style={card}>
        <p style={{ fontSize: 14, fontWeight: 700, margin: '0 0 8px' }}>🏢 {t('cr_company')}</p>
        {co.exists && <p style={{ fontSize: 12, margin: '0 0 8px', color: co.status === 'approved' ? C.primary : co.status === 'rejected' ? C.danger : C.muted }}>● {co.status}{co.status === 'pending' ? ' - ' + t('cr_wait_approve') : ''}</p>}
        <input style={inp} placeholder={t('cr_co_name')} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input style={inp} placeholder={t('cr_city_ph')} value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
        <input style={inp} placeholder={t('cr_web_ph')} value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} />
        <textarea style={{ ...inp, minHeight: 60 }} placeholder={t('cr_about_ph')} value={form.about} onChange={(e) => setForm({ ...form, about: e.target.value })} />
        <button style={btn()} onClick={saveCo}>{t('cr_save')}</button>
      </div>

      {co.exists && co.status === 'approved' && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>📋 {t('cr_my_jobs')} <span style={{ fontSize: 11, color: C.muted, fontWeight: 400 }}>({co.posts_used}/{co.free_posts} free{co.post_fee_pi > 0 ? ` · ${t('cr_next_fee')} ${co.post_fee_pi} Pi` : ''})</span></p>
            <button style={btn(C.indigo)} onClick={() => setShowPost(!showPost)}>+ {t('cr_post_job')}</button>
          </div>
          {showPost && (
            <div style={{ marginTop: 10, background: C.bg, borderRadius: 10, padding: 10 }}>
              <input style={inp} placeholder={t('cr_job_title')} value={jf.title} onChange={(e) => setJf({ ...jf, title: e.target.value })} />
              <select style={inp} value={jf.category} onChange={(e) => setJf({ ...jf, category: e.target.value })}>
                {cats.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
              <select style={inp} value={jf.job_type} onChange={(e) => setJf({ ...jf, job_type: e.target.value })}>
                {types.map((x) => <option key={x.key} value={x.key}>{x.label}</option>)}
              </select>
              <input style={inp} placeholder={t('cr_city_ph')} value={jf.city} onChange={(e) => setJf({ ...jf, city: e.target.value })} />
              <div style={{ display: 'flex', gap: 8 }}>
                <input style={inp} type="number" placeholder={t('cr_sal_min')} value={jf.salary_min} onChange={(e) => setJf({ ...jf, salary_min: e.target.value })} />
                <input style={inp} type="number" placeholder={t('cr_sal_max')} value={jf.salary_max} onChange={(e) => setJf({ ...jf, salary_max: e.target.value })} />
              </div>
              <textarea style={{ ...inp, minHeight: 80 }} placeholder={t('cr_desc')} value={jf.description} onChange={(e) => setJf({ ...jf, description: e.target.value })} />
              <textarea style={{ ...inp, minHeight: 60 }} placeholder={t('cr_reqs')} value={jf.requirements} onChange={(e) => setJf({ ...jf, requirements: e.target.value })} />
              <button style={{ ...btn(), opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={postJob}>{busy ? '...' : t('cr_post_now')}</button>
            </div>
          )}
          {jobs.map((j) => (
            <div key={j.id} style={{ borderTop: `0.5px solid ${C.border}`, padding: '10px 0', marginTop: 10 }}>
              <p style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>{j.title} <span style={{ fontSize: 11, color: j.status === 'live' ? C.primary : j.status === 'pending_payment' ? C.danger : C.muted }}>● {j.status}</span>{j.is_featured && <span style={{ fontSize: 10, color: C.indigo }}> ★</span>}</p>
              <p style={{ fontSize: 11, color: C.muted, margin: '3px 0 6px' }}>{j.views_count} views · {j.applications_count} {t('cr_applicants_n')}</p>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                <button style={btnGhost} onClick={() => setAppsFor(j)}>👥 {t('cr_applicants')}</button>
                {j.status === 'live' && !j.is_featured && <button style={btnGhost} onClick={() => feature(j)}>★ {t('cr_feature')}</button>}
                {j.status === 'pending_payment' && <button style={btn(C.danger)} onClick={() => payPi(co.post_fee_pi || 1, `XpertCareers job post: ${j.title}`, { job_id: j.id, type: 'careers_post' }, `${API}/jobs/${j.id}/pay/approve/`, `${API}/jobs/${j.id}/pay/complete/`, () => { alert('✅'); loadJobs(); }, () => {})}>{t('cr_pay_now')}</button>}
                {j.status === 'live' && <button style={btnGhost} onClick={() => closeJob(j)}>{t('cr_close')}</button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function AdminTab() {
  const [cos, setCos] = useState(null);
  const [st, setStF] = useState('pending');
  const load = useCallback(() => {
    fetch(`${API}/admin/companies/?status=${st}`, { headers: H() }).then((r) => r.json()).then((d) => setCos(d.companies || []));
  }, [st]);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (id, status) => {
    await fetch(`${API}/admin/companies/${id}/status/`, { method: 'POST', headers: H(), body: JSON.stringify({ status }) });
    load();
  };
  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {['pending', 'approved', 'rejected', 'all'].map((x) => <button key={x} style={chip(st === x)} onClick={() => setStF(x)}>{x}</button>)}
      </div>
      {!cos ? <p style={{ color: C.muted }}>{t('cr_loading')}</p>
        : cos.length === 0 ? <p style={{ color: C.muted, textAlign: 'center', padding: '1.5rem 0' }}>-</p>
          : cos.map((c) => (
            <div key={c.id} style={card}>
              <p style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>{c.name} <span style={{ fontSize: 11, color: C.muted, fontWeight: 400 }}>@{c.username} · {c.city}</span></p>
              {c.about && <p style={{ fontSize: 12, color: C.muted, margin: '4px 0' }}>{c.about}</p>}
              <p style={{ fontSize: 11, color: C.muted, margin: '2px 0 8px' }}>{c.jobs_count} jobs · {c.created_at} · ● {c.status}</p>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={btn()} onClick={() => setStatus(c.id, 'approved')}>✅ Approve</button>
                <button style={btn(C.danger)} onClick={() => setStatus(c.id, 'rejected')}>❌ Reject</button>
              </div>
            </div>
          ))}
    </div>
  );
}

export default function CareersApp({ user }) {
  const [tab, setTab] = useState('browse');
  const loggedIn = !!localStorage.getItem('token');
  const admin = isSuper() || (user && (user.is_staff || user.is_superuser));
  const tabStyle = (x) => ({
    padding: '10px 12px', fontSize: 13, fontWeight: 600, border: 'none',
    borderBottom: tab === x ? `2px solid ${C.primary}` : '2px solid transparent',
    background: 'transparent', color: tab === x ? C.primary : C.muted, cursor: 'pointer', whiteSpace: 'nowrap',
  });
  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '0.8rem', background: C.bg, minHeight: '100vh' }}>
      <p style={{ fontSize: 20, fontWeight: 800, margin: '6px 0 2px', color: C.text }}>🏢 XpertCareers</p>
      <p style={{ fontSize: 12, color: C.muted, margin: '0 0 10px' }}>{t('cr_tagline')}</p>
      <div style={{ display: 'flex', overflowX: 'auto', borderBottom: `0.5px solid ${C.border}`, marginBottom: 12 }}>
        <button style={tabStyle('browse')} onClick={() => setTab('browse')}>{t('cr_browse')}</button>
        {loggedIn && <button style={tabStyle('myapps')} onClick={() => setTab('myapps')}>{t('cr_my_apps')}</button>}
        {loggedIn && <button style={tabStyle('employer')} onClick={() => setTab('employer')}>{t('cr_employer')}</button>}
        {admin && <button style={tabStyle('admin')} onClick={() => setTab('admin')}>👑 Admin</button>}
      </div>
      {tab === 'browse' && <BrowseTab />}
      {tab === 'myapps' && <MyAppsTab />}
      {tab === 'employer' && <EmployerTab />}
      {tab === 'admin' && <AdminTab />}
    </div>
  );
}
